import { useAuthStoreShallow } from "@/features/authentication";
import { useRegisterAccountProperties } from "./use-register-account-properties";
import { useRegisterCounts } from "./use-register-counts-properties";
import { useRegisterFeatureFlags } from "./use-register-feature-flags";
import { useRegisterOnboardingGroup } from "./use-register-onboarding-group";
import { useRegisterUserProperties } from "./use-register-user-propertie";

export const useInitAnalytics = (): void => {
  const authenticated = useAuthStoreShallow((s) => !!s.orgId); // claims has orgId

  // Initialize all analytics subsystems when authenticated
  useRegisterUserProperties(authenticated);
  useRegisterAccountProperties(authenticated);
  useRegisterCounts(authenticated);
  useRegisterFeatureFlags(authenticated);
  useRegisterOnboardingGroup(authenticated);
};
